import { jsx as _jsx } from "react/jsx-runtime";
import ThumbnailBox from "./ThumbnailBox.js";
import ThumbnailIcon from "./ThumbnailIcon.js";
export default function ThumbnailIconBox(props) {
    const box = {
        border: props.border,
        variant: props.variant,
        highlighted: props.highlighted,
        onClick: props.onClick,
        onDoubleClick: props.onDoubleClick,
        aspectRatio: props.aspectRatio,
    };
    const icon = {
        icon: props.icon,
        children: props.iconText,
    };
    return (_jsx(ThumbnailBox, { ...box, children: _jsx(ThumbnailIcon, { ...icon }) }));
}
